/*    
<summary>
  This functional component "ChangeShiftPopupHOC" provides props to the child component.
  1. State "showChangeShiftPopup" that manages the show/hide of pop up
  2. Function "ChangeShiftPopupToggleHandler" to toggle the show/hide popup state "showChangeShiftPopup"
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date:26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from "react";

const AuthorizeCustomerPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAuthorizeCustomerPopup, setShowAuthorizeCustomerPopup] =
      useState<boolean>(false);

    const authorizeCustomerToggleHandler = () => {
      setShowAuthorizeCustomerPopup(!showAuthorizeCustomerPopup);
    };

    return (
      <Component
        showAuthorizeCustomerPopup={showAuthorizeCustomerPopup}
        authorizeCustomerToggleHandler={authorizeCustomerToggleHandler}
        {...props}
      />
    );
  };

export default AuthorizeCustomerPopupHOC;
